import StyledDateInput from "./StyledDateInput";

export default StyledDateInput;
